import { fontSmoothing, getFontFamily } from '../../typography';
import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    border: '2px solid rgba(0,0,0,0)',
    borderRadius: idsTokens.listItem.default.radius.standard,
    background: idsTokens.listItem.default.color.background.enabled,
    color: idsTokens.listItem.default.color.text.label.enabled,
    gap: idsTokens.listItem.default.spacing.standard.padding.gap,
    boxSizing: 'border-box',
    outline: 'none',
    minWidth: idsTokens.listItem.default.spacing.standard.min.width,
    minHeight: idsTokens.listItem.default.spacing.standard.min.height,
    paddingTop: idsTokens.listItem.default.spacing.standard.padding.top,
    paddingRight: idsTokens.listItem.default.spacing.standard.padding.right,
    paddingBottom: idsTokens.listItem.default.spacing.standard.padding.bottom,
    paddingLeft: idsTokens.listItem.default.spacing.standard.padding.left,

    fontFamily: getFontFamily(idsTokens),
    ...fontSmoothing,
    fontSize: idsTokens.typography.font.size.base,
    fontStyle: 'normal',
    fontWeight: idsTokens.typography.font.weight.regular,
    lineHeight: idsTokens.typography.lineHeight.base,
    letterSpacing: idsTokens.typography.spacing.letter.lg,

    // TODO find a real selector, Mui-sizeSmall does nothing
    '&.Mui-sizeSmall': {
      minWidth: idsTokens.listItem.default.spacing.small.min.width,
      minHeight: idsTokens.listItem.default.spacing.small.min.height,
      paddingTop: idsTokens.listItem.default.spacing.small.padding.top,
      paddingRight: idsTokens.listItem.default.spacing.small.padding.right,
      paddingBottom: idsTokens.listItem.default.spacing.small.padding.bottom,
      paddingLeft: idsTokens.listItem.default.spacing.small.padding.left,
      gap: idsTokens.listItem.default.spacing.small.padding.gap,
    },
    '&:hover': {
      color: idsTokens.listItem.default.color.text.label.hover,
      border: '2px solid rgba(0,0,0,0)',
      background: idsTokens.listItem.default.color.background.hover,
    },
    '&:focus-visible, &.Mui-focused': {
      color: idsTokens.listItem.default.color.text.label.focus,
      border: '2px solid rgba(0,0,0,0)',
      background: idsTokens.listItem.default.color.background.focus,
      outline: 'none',
      paddingTop: idsTokens.listItem.default.spacing.standard.padding.top,
      paddingRight: idsTokens.listItem.default.spacing.standard.padding.right,
      paddingBottom: idsTokens.listItem.default.spacing.standard.padding.bottom,
      paddingLeft: idsTokens.listItem.default.spacing.standard.padding.left,
      margin: 0,
    },
    '&.Mui-sizeSmall:focus-visible, &.Mui-sizeSmall.Mui-focused': {
      paddingTop: idsTokens.listItem.default.spacing.small.padding.top,
      paddingRight: idsTokens.listItem.default.spacing.small.padding.right,
      paddingBottom: idsTokens.listItem.default.spacing.small.padding.bottom,
      paddingLeft: idsTokens.listItem.default.spacing.small.padding.left,
    },
    /**
     * required to overwrite Autocomplete styles
     */
    '&.MuiAutocomplete-option.MuiListItem-root': {
      display: 'flex',
      boxSizing: 'border-box',
      paddingTop: idsTokens.listItem.default.spacing.standard.padding.top,
      paddingRight: idsTokens.listItem.default.spacing.standard.padding.right,
      paddingBottom: idsTokens.listItem.default.spacing.standard.padding.bottom,
      paddingLeft: idsTokens.listItem.default.spacing.standard.padding.left,
      margin: '0',
      alignItems: 'center',
    },
    '&.MuiAutocomplete-option.MuiListItem-root.Mui-focused, &.MuiAutocomplete-option.MuiListItem-root:focus-visible': {
      display: 'flex',
      alignItems: 'center',
      background: idsTokens.listItem.default.color.background.focus,
      border: '2px solid rgba(0,0,0,0)',
      outline: 'none',
      paddingTop: idsTokens.listItem.default.spacing.standard.padding.top,
      paddingRight: idsTokens.listItem.default.spacing.standard.padding.right,
      paddingBottom: idsTokens.listItem.default.spacing.standard.padding.bottom,
      paddingLeft: idsTokens.listItem.default.spacing.standard.padding.left,
      margin: '0',
      boxSizing: 'border-box',
    },
    '&.MuiAutocomplete-option.MuiListItem-root.Mui-sizeSmall, &.MuiAutocomplete-option.MuiListItem-root.Mui-sizeSmall:hover': {
      paddingTop: idsTokens.listItem.default.spacing.small.padding.top,
      paddingRight: idsTokens.listItem.default.spacing.small.padding.right,
      paddingBottom: idsTokens.listItem.default.spacing.small.padding.bottom,
      paddingLeft: idsTokens.listItem.default.spacing.small.padding.left,
    },
    '&.MuiAutocomplete-option.MuiListItem-root.Mui-sizeSmall.Mui-focused, &.MuiAutocomplete-option.MuiListItem-root.Mui-sizeSmall.Mui-focused:hover': {
      paddingTop: idsTokens.listItem.default.spacing.small.padding.top,
      paddingRight: idsTokens.listItem.default.spacing.small.padding.right,
      paddingBottom: idsTokens.listItem.default.spacing.small.padding.bottom,
      paddingLeft: idsTokens.listItem.default.spacing.small.padding.left,
    },
    /**
     * required by Autocomplete, MUI applies .Mui-focused using an onMouseOver
     * handler and the styles there have a higher specificity
     */
    '&.MuiAutocomplete-option.MuiListItem-root:hover': {
      background: idsTokens.listItem.default.color.background.hover,
      border: '2px solid rgba(0,0,0,0)',
    },
    '&.MuiAutocomplete-option.MuiListItem-root.Mui-focused:hover, &.MuiAutocomplete-option.MuiListItem-root:focus-visible:hover': {
      display: 'flex',
      alignItems: 'center',
      background: idsTokens.listItem.default.color.background.focus,
      border: '2px solid rgba(0,0,0,0)',
      outline: 'none',
      paddingTop: idsTokens.listItem.default.spacing.standard.padding.top,
      paddingRight: idsTokens.listItem.default.spacing.standard.padding.right,
      paddingBottom: idsTokens.listItem.default.spacing.standard.padding.bottom,
      paddingLeft: idsTokens.listItem.default.spacing.standard.padding.left,
      margin: '0',
    },
    '&.MuiAutocomplete-option.MuiListItem-root:active': {
      background: idsTokens.listItem.default.color.background.pressed,
      color: idsTokens.listItem.default.color.text.label.pressed,
    },
    '&[disabled], &[aria-disabled="true"], &.Mui-disabled': {
      color: idsTokens.listItem.default.color.text.label.disabled,
      border: '2px solid rgba(0,0,0,0)',
      background: idsTokens.listItem.default.color.background.disabled,
    },

    '&.Mui-error': {
      color: idsTokens.listItem.error.color.text.label.enabled,
      minWidth: idsTokens.listItem.error.spacing.standard.min.width,
      minHeight: idsTokens.listItem.error.spacing.standard.min.height,
      paddingTop: idsTokens.listItem.error.spacing.standard.padding.top,
      paddingRight: idsTokens.listItem.error.spacing.standard.padding.right,
      paddingBottom: idsTokens.listItem.error.spacing.standard.padding.bottom,
      paddingLeft: idsTokens.listItem.error.spacing.standard.padding.left,
      gap: idsTokens.listItem.error.spacing.standard.padding.gap,

      border: '2px solid rgba(0,0,0,0)',
      borderRadius: idsTokens.listItem.error.radius.standard,
      background: idsTokens.listItem.error.color.background.enabled,
    },
    '&.Mui-error.Mui-sizeSmall': {
      minWidth: idsTokens.listItem.error.spacing.small.min.width,
      minHeight: idsTokens.listItem.error.spacing.small.min.height,
      paddingTop: idsTokens.listItem.error.spacing.small.padding.top,
      paddingRight: idsTokens.listItem.error.spacing.small.padding.right,
      paddingBottom: idsTokens.listItem.error.spacing.small.padding.bottom,
      paddingLeft: idsTokens.listItem.error.spacing.small.padding.left,
      gap: idsTokens.listItem.error.spacing.small.padding.gap,
    },
    '&.Mui-error:hover': {
      color: idsTokens.listItem.error.color.text.label.hover,
      border: '2px solid rgba(0,0,0,0)',
      background: idsTokens.listItem.error.color.background.hover,
    },
    '&.Mui-error:focus, &.Mui-error.Mui-focused, &.Mui-error:focus-visible': {
      color: idsTokens.listItem.error.color.text.label.focus,
      border: '2px solid rgba(0,0,0,0)',
      background: idsTokens.listItem.error.color.background.focus,
      outline: 'none',
    },
    '&.Mui-error:active': {
      color: idsTokens.listItem.error.color.text.label.pressed,
      borderBottom: `0.5px solid ${idsTokens.listItem.error.color.border.pressed}`,
      background: idsTokens.listItem.error.color.background.pressed,
    },
    '&.Mui-error:active:focus': {
      color: idsTokens.listItem.error.color.text.label.pressed,
      borderBottom: `0.5px solid ${idsTokens.listItem.error.color.border.pressed}`,
      background: idsTokens.listItem.error.color.background.pressed,
    },
    '&.Mui-error[disabled], &.Mui-error[aria-disabled="true"], &.Mui-error.Mui-disabled': {
      color: idsTokens.listItem.error.color.text.label.disabled,
      border: '2px solid rgba(0,0,0,0)',
      background: idsTokens.listItem.error.color.background.disabled,
    },
  },
});
